import React from 'react';
import dayjs from 'dayjs';

type Props = {
  value: Date | null | undefined;
  format: string;
};

const DateTImeDiv: React.FC<Props> = (props) => {
  if (props.value == null || props.value == undefined) {
    return <div></div>;
  } else {
    const day1 = dayjs(props.value);
    return <div>{day1.format(props.format)}</div>;
  }
};

export default DateTImeDiv;
